import { LogoutButton } from "./buttons/LogoutButton"
import "../pages/login/login.css"

const NotAllowed = () => {

  return (
    <div className="content">
      <img src="/img/logoWhite.svg" alt="logo Goliaths blanc" />
      <p className="headline">Vous n’êtes pas autorisé à être ici.</p>
      <LogoutButton content="Déconnexion" variant="white" />
    </div>
  )
}

export default NotAllowed